import React from "react";
import { Calendar } from "react-date-range";
import { isAfter } from "date-fns";
import { CheckOutlined } from '@ant-design/icons';
import { Button, notification } from "antd";
import PopUp from "./PopUp";
import PlansPopUp from "./PlansPopUp";
import { checkMetricHistoryViolation } from "../utils/checkActivePlanViolations";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "../styles/components/date-popup.scss";

class DatePopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: props.date ? new Date(props.date) : new Date(),
      isPlansOpen: false
    };
  }

  handleChange(which, payload) {
    const isOutOfActivePlanHistory = checkMetricHistoryViolation(
      payload,
      this.props.activePlanHistoryPeriod
    );
    if (isOutOfActivePlanHistory) {
      this.showNotif(
        `${this.props.activePlanName} Plan`,
        `You can't see the history for this day.`
      );
    } else {
      this.setState(
        () => ({
          [which]: payload
        }),
        () => {}
      );
    }
  }

  showNotif = (title, text) => {
    const btn = (
      <Button
        onClick={() => {
          notification.close();
          this.setState({ isPlansOpen: true });
        }}
        type="primary"
        size="small"
      >
        Upgrade Plan
      </Button>
    );
    notification.config({
      duration: 10,
      placement: "bottomLeft"
    });
    const args = {
      message: title,
      description: text,
      btn
    };
    notification.warn(args);
  };

  setDate = () => {
    this.props.setDate(this.state.date);
    this.props.closePopUp();
  };

  render() {
    const minDate = isAfter(
      new Date(2018, 10, 5),
      new Date(this.props.creationTime)
    )
      ? new Date(2018, 10, 5)
      : new Date(this.props.creationTime);
    return (
      <div className="date-popup">
        <Calendar
          date={this.state.date}
          onChange={this.handleChange.bind(this, "date")}
          maxDate={new Date()}
          minDate={minDate}
        />
        <Button
          className="date-popup--set-date"
          onClick={this.setDate}
          type="primary"
          shape="round"
          icon={<CheckOutlined />}
        >
          Set Date
        </Button>
        {this.state.isPlansOpen && (
          <PopUp
            closePopUp={this.closePlans}
            closeOnOutClick={false}
            style={{ zIndex: 50 }}
          >
            <PlansPopUp />
          </PopUp>
        )}
      </div>
    );
  }
}

export default DatePopUp;
